import {registerRoute} from '@/router'
import {RECONCILIATION_LIST_VIEW, RECONCILIATION_VIEW} from '@/features/reconciliation/index'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'

const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()

const icon = 'i-ph-check-square-fill'

registerRoute(RECONCILIATION_LIST_VIEW)
registerRoute(RECONCILIATION_VIEW)

registerNavigationCommand({
    route: RECONCILIATION_LIST_VIEW,
    hotkey: 'k',
    icon,
    label: 'Kontoavstemming - liste (beta)',
})
registerNavigationCommand({
    route: RECONCILIATION_VIEW,
    icon,
    label: 'Kontoavstemming (beta)',
})

registerNavigationEntry(NavGroup.ACCOUNTING, {
    title: 'Kontoavstemming (beta)',
    key: 'reconciliation',
    icon,
    target: RECONCILIATION_VIEW,
    sortOrder: 1,
})
registerNavigationEntry(NavGroup.ACCOUNTING, {
    title: 'Kontoavstemming - liste (beta)',
    key: 'reconciliation-list',
    icon,
    target: RECONCILIATION_LIST_VIEW,
    sortOrder: 2,
})

registerHotkey('k', RECONCILIATION_LIST_VIEW)

buildSimpleCrumb(RECONCILIATION_LIST_VIEW, 'Kontoavstemming (beta)', icon)
buildSimpleCrumb(RECONCILIATION_VIEW, 'Kontoavstemming (beta)', icon)
